import { FC, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { setReferralToken } from '../../constants/referralToken';

const ReferralLand: FC = () => {
  const navigate = useNavigate();
  const { token } = useParams<{ token: string }>();

  useEffect(() => {
    if (token) {
      setReferralToken(token);
    }
    navigate('/sign-up', { replace: true });
  }, [token, navigate]);

  return null;
};

export default ReferralLand;
